export default "__VITE_ASSET__BjmznQDg__"